export default __webpack_public_path__ + "static/media/info.15046713.svg";